import { render, staticRenderFns } from "./ModalHistoricoEntrega.vue?vue&type=template&id=17d5f304"
import script from "./ModalHistoricoEntrega.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports